import { createResourceModule } from '../../../lib/resource/module.js';
import { pmsCredentialDetail } from './schemas.js';

/**
 * The PMS credentials module's API layer.
 *
 * The six CRUD paths and their hooks come from the shared factory; the
 * form payload builder is local because this module has boolean and array
 * fields that the generic builder cannot represent.
 */
export const pmsCredentials = createResourceModule({
  resource: 'pmsCredentials',
  basePath: '/v1/pms-credentials',
  detail: pmsCredentialDetail,
});
